export const DUPLICATE = 'DUPLICATE' as const;
export const ARCHIVE = 'ARCHIVE' as const;
export const TRASH = 'TRASH' as const;

export const GETTING_STARTED_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/get-started-with-advanced-roadmaps/';
